import axiosInstance from '../utils/axios';
import API_CONFIG from '../config/api.config';

const hsnReportService = {
  getHSNReport: async (startDate, endDate) => {
    try {
      const response = await axiosInstance.get(`${API_CONFIG.ENDPOINTS.REPORTS}/hsn`, {
        params: {
          startDate,
          endDate,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching HSN report:', error);
      throw error;
    }
  },
};

export default hsnReportService;

